import {
    useAppDispatch,
    useAppSelector,
} from 'app/hooks';
import {
    updateQuestionsDIL,
    setQuestionDetails,
    selectQuestionFilter,
    getQuestionsNotes,
    setQuestionData,
    toggleArrorEnable,
    setQuestionsNotes,
    getQuestionsReference
} from 'features/filters/filterSlice';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import CommanModal from 'components/elements/Modal/CommanModal'
import './QuestionDetails.css';
import SimpleReactValidator from 'simple-react-validator';
import { postFormData, postWithFile, getArrowFunction } from '../../../utils/service';
import { toast } from 'react-toastify';
import { confirm } from "react-confirm-box";
import ImageViewer from 'react-simple-image-viewer';
import { Markup } from 'interweave';
import {
    selectDashboard,
} from 'features/dashboard/dashboardSlice';
import NotesModal from '@element/Modal/NotesModal';
import { Button, Modal } from 'react-bootstrap-v5';
const isToggleEnale = true;
const QuestionDetails = (targetKey: any) => {
    const dispatch = useAppDispatch();
    const { data: dashboardData } = useAppSelector(selectDashboard);
    const {
        questionData,
        questionDetail,
        selectedFilters,
        subjectData,
        isQuestionRefresh,
        questionsNotes,
        questionsReference,
        pending,
        error,
    }: any = useAppSelector(selectQuestionFilter);
    const IS_ARROW_ENABLE = getArrowFunction();
    const [page, setPage] = useState('')
    const [keyPressed, setKeyPressed] = useState(false);
    const [leftKeyPressed, setLeftKeyPressed] = useState(false);
    const [rightKeyPressed, setRightKeyPressed] = useState(false);
    const [canShowFastrackLable, setCanShowFastrackLable] = useState(false);
    const useKeyPress = function (targetKey: any) {
        function downHandler({ key }: any) {
            if (key === targetKey) {
                if (targetKey === 'ArrowLeft') {
                    setLeftKeyPressed(true)
                } else if (targetKey === 'ArrowRight') {
                    setRightKeyPressed(true)
                }
                setKeyPressed(true);
            }
        }

        const upHandler = ({ key }: any) => {
            if (key === targetKey) {
                if (targetKey === 'ArrowLeft') {
                    setLeftKeyPressed(false)
                } else if (targetKey === 'ArrowRight') {
                    setRightKeyPressed(false)
                }
                setKeyPressed(false);
            }
        };

        React.useEffect(() => {
            window.addEventListener("keydown", downHandler);
            window.addEventListener("keyup", upHandler);

            return () => {
                window.removeEventListener("keydown", downHandler);
                window.removeEventListener("keyup", upHandler);
            };
        }, [keyPressed, targetKey]);

        return keyPressed;
    };

    useKeyPress("ArrowLeft");
    useKeyPress("ArrowRight");

    useEffect(() => {
        if (IS_ARROW_ENABLE && leftKeyPressed && currentIndex > 0) {
            setTimeout(() => {
                changeQuestion('prev')
            }, 100)
        }
    }, [leftKeyPressed])

    useEffect(() => {
        if (IS_ARROW_ENABLE && rightKeyPressed && currentIndex < questionData.length - 1) {
            setTimeout(() => {
                changeQuestion('next')
            }, 100)
        }
    }, [rightKeyPressed])

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isNotesModal, setIsNotesModal] = useState(false)
    const [isAddNotesModal, setIsAddNotesModal] = useState(false)
    const [isNotesLoading, setIsNotesLoading] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [previewImages, setPreviewImages] = useState([]);
    const [notesFormData, setNotesFormData] = useState({
        notes_text: "",
        notes_image: null,
        image_preview: null,
        notes_id: ""
    });
    const [, forceUpdate] = useState("");

    const options = [
        { key: 'doubt', title: 'Q in Doubt', isSelected: false },
        { key: 'done', title: 'Q Done', isSelected: false },
        { key: 'lmr', title: 'Q LDR', isSelected: false },
        { key: 'test', title: 'Q for Test', isSelected: false },
        // { key: 'solution', title: 'View Solution', isSelected: false },
        { key: 'notes', title: 'Input Notes, References & Upload Your Solution Image', isSelected: false }
    ]

    useEffect(() => {
        if (questionData.length > 0) {
            changeQuestion('first')
        }
    }, [isQuestionRefresh])
    useEffect(() => {
        return () => {
            dispatch(setQuestionData([]))
            dispatch(setQuestionDetails({}));
        }
    }, [])
    useEffect(() => {
        if (subjectData.length > 0 && selectedFilters.subject_id !== '') {
            let findSubject = subjectData.find((sub: any) => sub.subject_id === selectedFilters.subject_id);
            let flag = false;
            if (findSubject && findSubject.payment_status !== 'Free') {
                flag = true;
            }
            setCanShowFastrackLable(flag)
        }
    }, [selectedFilters, subjectData])

    const goToPage = () => {
        let index = null;
        let p = Number(page);
        if (p > 0 && p <= questionData.length) {
            dispatch(setQuestionDetails({}));
            if (questionData[p - 1]) {
                index = p - 1;
                setCurrentIndex(index)
                setSelectedQuestion(index)
            } else {
                toast.warn("Invalid question page.")
            }
        } else {
            toast.warn("Invalid question page.")
        }
    }

    const changeQuestion = (type: string) => {
        dispatch(setQuestionDetails({}));
        let index = null;
        if (type === 'prev') {
            if (questionData[currentIndex - 1]) {
                index = currentIndex - 1;
                setCurrentIndex(index)
                setSelectedQuestion(index)
            }
        } else if (type === 'next') {
            if (questionData[currentIndex + 1]) {
                index = currentIndex + 1;
                setCurrentIndex(index)
                setSelectedQuestion(index)
            }
        } else if (type === 'first') {
            index = 0;
            setCurrentIndex(index)
            setSelectedQuestion(index)
        } else if (type === 'last') {
            index = questionData.length - 1;
            setCurrentIndex(index)
            setSelectedQuestion(index)
        }
    }

    const setSelectedQuestion = (index: any, details = null) => {
        let questObj: any = null
        if (details) {
            questObj = JSON.parse(JSON.stringify(details));
        } else {
            questObj = { ...questionData[index] };
        }

        var imagesList = [];
        var videosList = [];
        var pdfLinks = [];
        if (questObj.question_image != undefined) {
            let images = questObj.question_image.split(',');
            imagesList = images.map((item: any, i: number) => {
                return { type: 'image', url: item };
            });
            imagesList = imagesList.filter((item: any, i: number) => {
                return item.url != '';
            });
        }

        if (questObj.question_video != undefined) {
            let videos = questObj.question_video.split(',');
            videosList = videos.map((item: any, i: number) => {
                return { type: 'video', url: item };
            });
            videosList = videosList.filter((item: any, i: number) => {
                return item.url != '';
            });
        }

        if (questObj.question_pdf != undefined) {
            let links = questObj.question_pdf.split(',');
            pdfLinks = links.map((item: any, i: number) => {
                return { type: 'pdf', icon: 'ic_pdf', url: item };
            });
            pdfLinks = pdfLinks.filter((item: any, i: number) => {
                return item.url != '';
            });
        }

        //Added to incorporate solution image and show it solution screen
        var imagesList_solution = [];
        var videosList_solution = [];
        var pdfLinks_solution = [];

        if (questObj.solution_image != undefined) {
            let images = questObj.solution_image.split(',');
            imagesList_solution = images.map((item: any, i: number) => {
                return { type: 'image', url: item };
            });
            imagesList_solution = imagesList_solution.filter((item: any, i: number) => {
                return item.url != '';
            });
        }

        if (questObj.solution_video != undefined) {
            let videos = questObj.solution_video.split(',');
            videosList_solution = videos.map((item: any, i: number) => {
                return { type: 'video', url: item };
            });
            videosList_solution = videosList_solution.filter((item: any, i: number) => {
                return item.url != '';
            });
        }

        if (questObj.solution_pdf != undefined) {
            let links = questObj.solution_pdf.split(',');
            pdfLinks_solution = links.map((item: any, i: number) => {
                return { type: 'pdf', icon: 'ic_pdf', url: item };
            });
            pdfLinks_solution = pdfLinks_solution.filter((item: any, i: number) => {
                return item.url != '';
            });
        }

        var bookList = questObj.books.map((item: any, i: number) => {
            var description = ''; //item.books_involved_names
            if (
                item.book_details_year != undefined &&
                item.book_details_year != ''
            ) {
                description = item.book_details_year + '';
            }

            if (
                item.books_involved_pg != undefined &&
                item.books_involved_pg != ''
            ) {
                description =
                    description +
                    (item.book_details_year != undefined && item.book_details_year != ''
                        ? '\nPage '
                        : 'Page ') +
                    item.books_involved_pg;
            }

            if (
                item.books_involved_pg != undefined &&
                item.books_involved_pg != '' &&
                item.books_involved_qt != undefined &&
                item.books_involved_qt != ''
            ) {
                description = description + ' - ';
            } else {
                description = description + '\n';
            }

            if (
                item.books_involved_qt != undefined &&
                item.books_involved_qt != ''
            ) {
                description = description + 'Question ' + item.books_involved_qt;
            }

            return {
                key: item.book_id,
                title: item.books_involved_sc,
                name: item.books_involved_names,
                desc: description,
                isSelected: false,
            };
        });

        //Set DILMR status in question object
        var hasDoubt = questObj.doubt;
        var isImp = questObj.imp;
        var isLMR = questObj.lmr;
        var isTest = questObj.test;

        if (hasDoubt == undefined) questObj.doubt = 'y';
        if (isImp == undefined) questObj.imp = 'y';
        if (isLMR == undefined) questObj.lmr = 'y';
        if (isTest == undefined) questObj.test = 'y';

        let actionOption: any = JSON.parse(JSON.stringify(options))
        let updatedOptions = actionOption.map((option: any) => {
            switch (option.key) {
                case 'doubt':
                    option.isSelected = questObj.doubt == 'y';
                    break;
                case 'done':
                    option.isSelected = questObj.imp == 'y';
                    break;
                case 'lmr':
                    option.isSelected = questObj.lmr == 'y';
                    break;
                case 'test':
                    option.isSelected = questObj.test == 'y';
                    break;
                case 'notes':
                    option.isSelected = [
                        questObj.user_notes,
                        questObj.book_no,
                        questObj.book_page_no,
                        questObj.question_no,
                        questObj.question_page_no
                    ].some(value => value && value.trim() !== '');
                    break;
                default:
                    break;
            }
            return option;
        });
        questObj['booksInvolved'] = bookList;
        questObj['links'] = pdfLinks;
        questObj['solution_links'] = pdfLinks_solution;
        questObj['solution_images'] = imagesList_solution.concat(videosList_solution);
        questObj['images'] = imagesList.concat(videosList);
        questObj['links'] = pdfLinks;
        questObj['options'] = updatedOptions;
        // let selectedQuestion = questObj
        setTimeout(() => {
            dispatch(setQuestionDetails(questObj));
        })
        // dispatch(getQuestionsReference({ question_id: questObj.id }))
    }

    const updateQuestionAction = (type: string, value: any) => {
        var question = { ...questionDetail }
        var action = undefined;
        let options = JSON.parse(JSON.stringify(question.options));
        switch (type) {
            case 'doubt':
                action = 'D';
                question.doubt = !value ? 'n' : 'y';
                options[0].isSelected = value;
                break;
            case 'done':
                action = 'I';
                question.imp = !value ? 'n' : 'y';
                options[1].isSelected = value;
                break;
            case 'lmr':
                action = 'R';
                question.lmr = !value ? 'n' : 'y';
                options[2].isSelected = value;
                break;
            case 'test':
                action = 'T';
                question.test = !value ? 'n' : 'y';
                options[3].isSelected = value;
                break;
            case 'notes':
                action = 'N';
                break;
            default:
                break;
        }
        if (action != undefined && action !== 'N') {
            question.options = options;

            let params = {
                question_id: questionDetail.id,
                action: action,
                // token: 'MTk3'
            }
            dispatch(updateQuestionsDIL(params));
            dispatch(setQuestionDetails(question));
            let qData = JSON.parse(JSON.stringify(questionData));
            qData[currentIndex] = question;
            dispatch(setQuestionData(qData))
        } else if (action === 'N') {
            dispatch(setQuestionsNotes([]))
            dispatch(getQuestionsNotes({ question_id: questionDetail.id }))
            // dispatch(getQuestionsReference({ question_id: questionDetail.id }))
            setIsNotesModal(true)
        }

    }
    useEffect(() => {
        if (questionsNotes.length > 0) {
            let images: any = [];
            questionsNotes.map((image: any) => {
                if (image.notes_image) {
                    images.push(image.notes_image)
                }
            });
            dispatch(toggleArrorEnable(false))
            setPreviewImages(images)
        }
    }, [questionsNotes])

    const rendarOptions = (item: any, index: number) => {
        return (
            <div className="form-check form-switch" key={`option_${index}`}>
                <input
                    className="form-check-input cursor-pointer"
                    type="checkbox"
                    role="switch"
                    id={`flexSwitchCheckChecked_${item.key}`}
                    checked={(!item.isSelected) ? true : false}
                    onChange={(e) => {
                        updateQuestionAction(item.key, !e.target.checked)
                    }}

                />
                <label className="form-check-label" >{item.title}</label>
            </div>
        )
    }

    const handleClose = () => {
        dispatch(toggleArrorEnable(true))
        setIsNotesModal(false)
    }

    const viewAllBooksHover = () => {
        let table = `
            <table className="table table-hover table-bordered book-table">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Book Name</th>
                    <th scope="col">Involved</th>
                    <th scope="col">Year</th>
                    <th scope="col">Page</th>
                    <th scope="col">Question</th>
                </tr>
            </thead>
            <tbody>`;

        {
            questionDetail.books && questionDetail.books.map((book: any, key: number) => {
                table += `<tr key="book_${key}">
                        <td scope="row">${key + 1}</td>
                        <td>${book.books_involved_sc}</td>
                        <td>${book.books_involved_names}</td>
                        <td width={400}>${book.book_details_year}</td>
                        <td width={200}>${book.books_involved_pg}</td>
                        <td width={200}>${book.books_involved_qt}</td>

                    </tr>`
            })
        }

        table += `</tbody>
        </table>`;

        return (
            <>
                <span
                    data-tip={`
                    ${table}
                        `}
                    data-for={'all_books'}

                    className="customBadge cursor-pointer z-index">
                    View All Books
                </span>
                <ReactTooltip
                    className='opaque'
                    backgroundColor={'#FFFFFF'}
                    textColor={'#000000'}
                    id={'all_books'}
                    place="top"
                    type="dark"
                    effect='solid'
                    multiline={true}
                    html={true}
                />
            </>
        )
    }
    const openAddNotes = (notes: any = null) => {
        if (notes) {
            setIsEditMode(true)
            setNotesFormData({
                notes_text: notes.notes_text,
                notes_image: null,
                image_preview: notes.notes_image,
                notes_id: notes.notes_id
            })

        } else {
            setIsEditMode(false)
            setNotesFormData({
                notes_text: "",
                notes_image: null,
                image_preview: null,
                notes_id: ""
            })
        }
        setIsNotesModal(false);
        setIsAddNotesModal(true);
    }
    const handleAddNotesClose = () => {
        setIsEditMode(false)
        setIsAddNotesModal(false);
        setIsNotesModal(true);
    }

    const validator = useRef(
        new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
    );

    const handleChange = (e: any) => {
        setNotesFormData({ ...notesFormData, [e.target.name]: e.target.value });
    };


    const submitAddEditNotes = async (e: any) => {
        e.preventDefault();
        const formValid = validator.current.allValid();
        if (formValid) {
            setIsNotesLoading(true)
            let params: any = {
                notes_text: notesFormData.notes_text,
                question_id: questionDetail.id,
                notes_id: notesFormData.notes_id
            }
            if (notesFormData.notes_image) {
                params.notes_image = notesFormData.notes_image;
            }
            let response: any = await postWithFile('questions_notes_update', params)
            if (response.success == "true") {
                var question = { ...questionDetail }
                question.user_notes = notesFormData.notes_text;//'test';
                let actionOption: any = JSON.parse(JSON.stringify(options))
                let updatedOptions = actionOption.map((option: any) => {
                    switch (option.key) {
                        case 'notes':
                            option.isSelected = question.user_notes != '';
                            break;
                        default:
                            break;
                    }
                    return option;
                });
                question['options'] = updatedOptions;
                dispatch(setQuestionDetails(question));
                let qData = JSON.parse(JSON.stringify(questionData));
                qData[currentIndex] = question;
                dispatch(setQuestionData(qData))
                setSelectedQuestion(false, question)

                setNotesFormData({
                    notes_text: "",
                    notes_image: null,
                    image_preview: null,
                    notes_id: ""
                })
                toast.success(response.message)
                dispatch(getQuestionsNotes({ question_id: questionDetail.id }))
                setIsNotesLoading(false)
                setIsAddNotesModal(false);
                setIsNotesModal(true);
            } else {
                setIsNotesLoading(false)
                toast.error(response.message)
            }
        } else {
            validator.current.showMessages();
        }
    }

    const deleteNotesImage = async (notes_id: any) => {
        const options: any = {
            render: (message: any, onConfirm: any, onCancel: any) => {
                return (
                    <div className='bg-black p-3'>
                        <div className='text-white'> {message} </div>
                        <div className="d-flex justify-content-evenly mt-4">
                            <button className="btn btn-secondary" onClick={onCancel}> Cancel </button>
                            <button className="btn btn-success" onClick={onConfirm}> Okay </button>
                        </div>

                    </div>
                );
            }
        };
        const result = await confirm("Do you want to delete current image?", options);
        if (result) {
            setIsNotesLoading(true)
            let params: any = { notes_id: notes_id }
            let response: any = await postFormData('questions_notes_img_delete', params)
            if (response.success == "true") {
                setNotesFormData({ ...notesFormData, image_preview: null })
                toast.success(response.message)
                dispatch(getQuestionsNotes({ question_id: questionDetail.id }))
                setIsNotesLoading(false)
            } else {
                setIsNotesLoading(false)
                toast.error(response.message)
            }
        }

    }
    const openImageViewer = useCallback((index: number) => {
        // document.body.classList.add('overflow-hidden');
        setCurrentImage(index);
        setIsViewerOpen(true);
    }, []);
    //not in use
    const closeImageViewer = () => {
        // document.body.classList.remove('overflow-hidden');
        setCurrentImage(0);
        setIsViewerOpen(false);
    };

    const [classesInput, setClassesInput] = useState({ type: 'classes', question_no: '', question_page_no: '' });
    const [booksInput, setBooksInput] = useState({ type: 'books', book_no: '', book_page_no: '' });

    useEffect(() => {
        if (isNotesModal) {
            // if(questionsReference){
            setClassesInput({ type: 'classes', question_no: questionDetail.question_no || '', question_page_no: questionDetail.question_page_no || '' })
            setBooksInput({ type: 'books', book_no: questionDetail.book_no || '', book_page_no: questionDetail.book_page_no || '' })
            // }else{
            //     setClassesInput({type: 'classes', question_no: '', question_page_no: ''})
            //     setBooksInput({type: 'books', book_no: '', book_page_no: ''})
            // }
        }
    }, [isNotesModal, questionDetail])

    const notesRender = () => {
        const _handleSave = async (type = '') => {
            let params: any = { question_id: questionDetail.id };
            var question = { ...questionDetail }
            if (type === 'classes') {
                question['question_no'] = classesInput.question_no;
                question['question_page_no'] = classesInput.question_page_no;
                params = { ...params, ...classesInput };
            } else {
                question['book_no'] = booksInput.book_no;
                question['book_page_no'] = booksInput.book_page_no;
                params = { ...params, ...booksInput };
            }
            let response: any = await postFormData('questions_reference_update', params)
            if (response.success == "true") {
                // setNotesFormData({ ...notesFormData, image_preview: null })
                toast.success(response.message)
                // dispatch(getQuestionsNotes({ question_id: questionDetail.id }))
                // setIsNotesLoading(false)
                let actionOption: any = JSON.parse(JSON.stringify(options))
                let updatedOptions = actionOption.map((option: any) => {
                    switch (option.key) {
                        case 'notes':
                            option.isSelected = [
                                question.user_notes,
                                question.book_no,
                                question.book_page_no,
                                question.question_no,
                                question.question_page_no
                            ].some(value => value && value.trim() !== '');
                            break;
                        default:
                            break;
                    }
                    return option;
                });
                question['options'] = updatedOptions;
                dispatch(setQuestionDetails(question));
                let qData = JSON.parse(JSON.stringify(questionData));
                qData[currentIndex] = question;
                dispatch(setQuestionData(qData))
                setSelectedQuestion(false, question)


                // dispatch(setQuestionDetails(question));
                // let qData = JSON.parse(JSON.stringify(questionData));
                // qData[currentIndex] = question;
                console.log('question....', question)
                console.log('questionData....', qData)
                // dispatch(setQuestionData(qData))

            } else {
                // setIsNotesLoading(false)
                toast.error(response.message)
            }
        }
        const handleInputChange = (e: any) => {
            const { name, value } = e.target;

            if (name in classesInput) {
                setClassesInput(prevState => ({ ...prevState, [name]: value }));
            } else if (name in booksInput) {
                setBooksInput(prevState => ({ ...prevState, [name]: value }));
            }
        }

        return (
            <NotesModal size="xl" title="Notes" isOpen={isNotesModal} handleClose={handleClose} onPress={() => openAddNotes()} titleButton="Add Notes">
                <table className="table table-hover table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Description</th>
                            <th scope="col">Image</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {questionsNotes && questionsNotes.map((notes: any, key: number) => {
                            return (
                                <tr key={`notes_${key}`}>
                                    <td width={100} scope="row">{key + 1}</td>
                                    <td ><Markup content={notes.notes_text} /> </td>
                                    <td width={150}>{notes.notes_image && <div onClick={() => openImageViewer(key)}><img src={notes.notes_image} style={{ width: "100%", height: "100px" }} /></div>}</td>
                                    <td width={100}><button onClick={() => openAddNotes(notes)} className="btn btn-primary">View</button></td>

                                </tr>
                            )
                        })}


                    </tbody>
                </table>
                <div className='d-flex justify-content-end'>
                    <Button variant="primary" onClick={() => openAddNotes()}>
                        Add Notes
                    </Button>
                </div>
                <div>
                    <h6>Classes</h6>
                    <div className='row'>
                        <div className='col-md-5'>
                            <div className='form-group d-flex align-items-center'>
                                <label style={{ width: '20%' }}>Q. No.</label>
                                <input type='text' className='form-control' onChange={handleInputChange} value={classesInput.question_no} name='question_no' maxLength={5}/>
                            </div>
                        </div>
                        <div className='col-md-5'>
                            <div className='form-group d-flex align-items-center'>
                                <label style={{ width: '20%' }}>Page. No.</label>
                                <input type='text' className='form-control' onChange={handleInputChange} value={classesInput.question_page_no} name='question_page_no'  maxLength={4}/>
                            </div>
                        </div>
                        <div className='col-md-2'>
                            <button type='button' className='btn btn-info' onClick={() => _handleSave('classes')}>Save</button>
                        </div>
                    </div>

                </div>

                <div className='mt-5'>
                    <h6>Solved</h6>
                    <div className='row'>
                        <div className='col-md-5'>
                            <div className='form-group d-flex align-items-center'>
                                <label style={{ width: '20%' }}>Book No.</label>
                                <input type='text' className='form-control' onChange={handleInputChange} value={booksInput.book_no} name='book_no' maxLength={5}/>
                            </div>
                        </div>
                        <div className='col-md-5'>
                            <div className='form-group d-flex align-items-center'>
                                <label style={{ width: '20%' }}>Page. No.</label>
                                <input type='text' className='form-control' onChange={handleInputChange} value={booksInput.book_page_no} name='book_page_no' maxLength={4} />
                            </div>
                        </div>
                        <div className='col-md-2'>
                            <button type='button' className='btn btn-info' onClick={() => _handleSave('books')}>Save</button>
                        </div>
                    </div>

                </div>
                <Modal.Footer className='mt-3'>
                    <Button variant="secondary" onClick={() => handleClose()}>
                        Close
                    </Button>
                </Modal.Footer>
            </NotesModal>
        )
    }

    const addEditNotes = () => {

        return (
            <CommanModal isLoading={isNotesLoading} size="lg" title={(isEditMode) ? "Edit Notes" : "Add Notes"} isOpen={isAddNotesModal} handleClose={handleAddNotesClose} onPress={submitAddEditNotes} titleButton={(isEditMode) ? "Update" : "Add"} >
                <form>
                    <div className="form-group mb-3">
                        <label >Notes</label>
                        <textarea rows={6} name="notes_text" value={notesFormData.notes_text} onChange={(e) => handleChange(e)} className="form-control" placeholder="Enter your notes"></textarea>


                        {validator.current.message(
                            "notes_text",
                            notesFormData.notes_text,
                            "required",
                            { className: "text-danger" }
                        )}
                    </div>
                    <div className="form-group mb-3">
                        <label >Upload Image</label>
                        <input type="file" name="notes_image" className="form-control" id="customFileLang"
                            onChange={(e) => {
                                setNotesFormData({
                                    ...notesFormData,
                                    [e.target.name]: (e.target.files) ? e.target.files[0] : null,
                                });
                            }}
                        //onChange={(e) => handleChange(e)}
                        />

                    </div>
                    {notesFormData.image_preview && <div className="form-group mt-3">
                        <div className="img-preview col-md-4">
                            <div className="close-btn" onClick={() => deleteNotesImage(notesFormData.notes_id)}>
                                <i className="fa fa-times"></i>
                            </div>
                            <img src={notesFormData.image_preview} style={{ width: '100%', height: '100%' }} />
                        </div>

                    </div>}
                </form>
            </CommanModal>
        )
    }

    const renderSelectedQuestion = () => {
        let selectedQuestion = questionDetail;

        return (
            <div className="row">
                {/* <ReactTooltip /> */}
                <div className="col-md-12">
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="fs-5">Question No. - {selectedQuestion.sequence_no}</span>
                        <span className="fw-bold">{selectedQuestion.category_name}</span>
                    </div>

                    <hr className="text-white" />
                    <div className='que-fix'>
                        <p className="text-white que-height">{selectedQuestion.question_text}</p>
                    </div>

                </div>
                <div className="col-md-12">
                    <div className="h-100 bg-blue rounded-3">
                        <div className="d-flex justify-content-between">
                            <p className="text-blue">Books Involved - Credit to ICAI</p>
                            {/* <span className="cursor-pointer" 
                            onClick={() => viewAllBooks()}
                            >View All Books</span> */}
                            {viewAllBooksHover()}
                        </div>

                        <div className="scrolledView1">
                            {/* <p data-tip="hello world">Tooltip</p> */}
                            {/* <div data-tip={'data'} data-for={'randomID'}>test</div>
                            <ReactTooltip id={'randomID'} effect='solid' /> */}
                            {selectedQuestion.books && selectedQuestion.books.map((book: any, key: number) => {
                                let bookTitle = book.books_involved_names;
                                let bookYear = '';
                                if (book.book_details_year && book.book_details_year !== '') {
                                    bookYear = `${book.book_details_year}`
                                }
                                let seprator = (book?.books_involved_pg !== '' && book?.books_involved_qt !== '') ? ' - ' : '';
                                return (
                                    <span key={`books_${key}`}>

                                        <div
                                            data-tip={`
                                            <div style="min-height:100px;font-size: 16px">
                                                <div >
                                                    <b>${bookTitle}</b>    
                                                </div>
                                               
                                                <div style="margin-top: 10px; font-weight: bold">
                                                ${bookYear}
                                                </div>
                                                <div style="margin-top: 5px; font-weight: bold">
                                                ${book?.books_involved_pg !== '' ? 'Page ' + book.books_involved_pg : ''}${seprator}${book?.books_involved_qt !== '' ? 'Question ' + book.books_involved_qt : ''}
                                                </div>
                                                </div>
                                                `}
                                            data-for={book.book_id}

                                            className="customBadge bg-primary cursor-pointer">
                                            {book.books_involved_sc}
                                        </div>
                                        <ReactTooltip
                                            className='opaque'
                                            backgroundColor={'#FFFFFF'}
                                            textColor={'#000000'}
                                            id={book.book_id}
                                            place="top"
                                            type="dark"
                                            effect='solid'
                                            multiline={true}
                                            html={true}
                                        // getContent={() => { return null }}

                                        />
                                    </span>
                                )
                            }
                            )}
                        </div>
                        <hr />
                        <div className="text-white fw-bold py-2 d-flex justify-content-between"><div>Bookmark Your Own</div>
                        <div className='d-flex flex-row'>
                                {(selectedQuestion.is_ambiguous_active === "1" && canShowFastrackLable) && <label className="form-check-label fw-bold color-yellow" >Ambiguous Q</label>}
                                {(dashboardData?.is_fastrack_active === "1" && selectedQuestion.is_fastrack_active === "1" && canShowFastrackLable) ? <label className="form-check-label fw-bold color-orange pl-10" >Fast Track Q</label> : <label className="form-check-label fw-bold color-orange" >&nbsp;</label>}
                            </div>

                        </div>
                        <div className="actions d-flex justify-content-between py-2">
                            {selectedQuestion?.options && selectedQuestion.options.map((item: any, key: number) => rendarOptions(item, key))}
                            {/* <div className='d-flex flex-column'>
                                {(dashboardData?.is_fastrack_active === "1" && selectedQuestion.is_fastrack_active === "1" && canShowFastrackLable) ? <label className="form-check-label fw-bold color-orange" >Fast Track Q</label> : <label className="form-check-label fw-bold color-orange" >&nbsp;</label>}
                                {(selectedQuestion.is_ambiguous_active === "1" && canShowFastrackLable) && <label className="form-check-label fw-bold color-yellow" >Ambiguous Q</label>}
                            </div> */}
                        </div>
                        {(selectedQuestion.question_no || selectedQuestion.question_page_no || selectedQuestion.book_no || selectedQuestion.book_page_no) &&
                            <div className='row d-flex align-items-center font-14'>
                                <div className='col-md-6' style={{paddingRight: '5px'}}>
                                    {(selectedQuestion.question_no || selectedQuestion.question_page_no) &&
                                        <div className='d-flex flex-column'>
                                            <div className='ref-title'>Classes</div>
                                            <div className='input-box'><b>Q. No.:</b> <span className='input-color'>{selectedQuestion.question_no}</span> / <b>Page. No.:</b> <span className='input-color'>{selectedQuestion.question_page_no}</span></div>
                                        </div>}
                                </div>
                                <div className='col-md-6' style={{paddingLeft: '0px'}}>
                                    {(selectedQuestion.book_no || selectedQuestion.book_page_no) &&
                                        <div className='d-flex flex-column'>
                                            <div className='ref-title'>Solved</div>
                                            <div className='input-box'><b>Book No.:</b> <span className='input-color'>{selectedQuestion.book_no}</span> / <b>Page. No.:</b> <span className='input-color'>{selectedQuestion.book_page_no}</span></div>
                                        </div>}
                                </div>
                            </div>}
                        <hr />
                        <div className="d-flex justify-content-between mt-3">
                            <div className="d-flex">
                                <div className="pagination-btn">
                                    <button type="button" className="btn btn-outline-light" disabled={currentIndex === 0} onClick={() => changeQuestion('prev')}><i className="fas fa-chevron-left"></i></button>
                                    <label>Previous</label>
                                </div>
                                <div className="pagination-btn">
                                    <button type="button" className="btn btn-outline-light" disabled={currentIndex === 0} onClick={() => changeQuestion('first')}><i className="fas fa-angle-double-left"></i></button>
                                    <label>First</label>
                                </div>

                            </div>
                            <div className="d-flex">
                                <input type='number' onChange={(e) => setPage(e.target.value)} className='page-text-input' name='page' value={page} /><button onClick={() => goToPage()} className='btn btn-go ms-2'>Go</button>
                            </div>
                            <div className="d-flex">
                                <div className="pagination-btn">
                                    <button type="button" className="btn btn-outline-light" disabled={currentIndex === questionData.length - 1} onClick={() => changeQuestion('last')}><i className="fas fa-angle-double-right"></i></button>
                                    <label>Last</label>
                                </div>
                                <div className="pagination-btn">
                                    <button type="button" className="btn btn-outline-light" disabled={currentIndex === questionData.length - 1} onClick={() => changeQuestion('next')}><i className="fas fa-chevron-right"></i></button>
                                    <label>Next</label>
                                </div>


                            </div>
                        </div>
                        <div className="d-flex justify-content-end mt-1">
                            {currentIndex + 1} / {questionData.length}
                        </div>
                    </div>
                </div>
                {notesRender()}
                {addEditNotes()}
                <div style={{ zIndex: 99999 }}>
                    {isViewerOpen && (
                        <ImageViewer
                            backgroundStyle={{ backgroundColor: '#030822de' }}
                            src={previewImages}
                            currentIndex={currentImage}
                            disableScroll={false}
                            closeOnClickOutside={true}
                            onClose={closeImageViewer}
                        />
                    )}
                </div>
                {/* <CommanModal size="xl" title="Books Involved" isOpen={isBooksModal} handleClose={handleClose}>
                    <table className="table table-hover table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Book Name</th>
                                <th scope="col">Involved</th>
                                <th scope="col">Year</th>
                                <th scope="col">Page</th>
                                <th scope="col">Question</th>
                            </tr>
                        </thead>
                        <tbody>
                            {questionDetail.books && questionDetail.books.map((book: any, key: number) => {
                                return (
                                    <tr key={`book_${key}`}>
                                        <td scope="row">{key + 1}</td>
                                        <td>{book.books_involved_sc}</td>
                                        <td>{book.books_involved_names}</td>
                                        <td width={200}>{book.book_details_year}</td>
                                        <td width={200}>{book.books_involved_pg}</td>
                                        <td width={200}>{book.books_involved_qt}</td>

                                    </tr>
                                )
                            })}


                        </tbody>
                    </table>
                </CommanModal> */}
            </div>
        );
    }

    return (
        <div className="d-flex flex-column flex-shrink-0 text-white sidebar col-md-4 right-border text-start mb-pd-x-5 question-details">
            {questionData.length > 0 ?
                renderSelectedQuestion() : <div className="empty-data">Question details will be display here.</div>}
        </div>
    )
};

export default QuestionDetails;
